import {Action, createReducer, on} from '@ngrx/store';

import * as generalActions from './general.actions';
import {UserState} from '../../users/redux/users.reducers';
import {RoleState} from '../../roles/redux/roles.reducers';
import {ProductState} from '../../products/redux/products.reducer';
import {CatalogueState} from '../../catalogs/redux/catalogs.reducer';
import {CustomerState} from '../../customers/redux/customers.reducer';
import {ProviderState} from '../../providers/redux/providers.reducer';
import {AuthState} from '../../authentication/redux/authentication.reducers';
import {BranchOfficeState} from '../../branch-offices/redux/branch-offices.reducers';
import {ConfigurationState} from '../../configurations/redux/configurations.reducer';
import { InventoriesState } from 'app/main/inventories/redux/inventories.reducers';
import { ProprietorsState } from 'app/main/proprietors/redux/proprietors.reducers';
import { PropertiesState } from 'app/main/properties/redux/properties.reducers';
import { UnitsState } from 'app/main/units/redux/units.reducers';
import { ContractsState } from 'app/main/contracts/redux/contracts.reducers';
import { PaymentState } from 'app/main/payments/redux/payments.reducer';
import { ExpenseState } from 'app/main/expenses/redux/expenses.reducer';
import { PurchaseState } from 'app/main/purchases/redux/purchases.reducers';
import { RemissionState } from 'app/main/remissions/redux/remissions.reducers';
import { BillState } from 'app/main/bills/redux/bills.reducers';
import { QuotationState } from 'app/main/quotations/redux/quotations.reducers';
import { AnnexState } from 'app/main/company-annexes/redux/company-annexes.reducer';

export class AppState {
    auth: AuthState;
    general: GeneralState;
    customers: CustomerState;
    branchOffices: BranchOfficeState;
    providers: ProviderState;
    products: ProductState;
    catalogs: CatalogueState;
    users: UserState;
    roles: RoleState;
    configurations: ConfigurationState;
    inventoriesStore: InventoriesState;
    proprietorsStore: ProprietorsState;
    propertiesStore: PropertiesState;
    unitsStore: UnitsState;
    contractsStore: ContractsState;
    payments: PaymentState;
    expenses: ExpenseState;
    purchases: PurchaseState;
    remissions: RemissionState;
    bills: BillState;
    quotations: QuotationState;
    annexes: AnnexState
}

export class GeneralState {
    showLoading: boolean;

    constructor() {
        this.showLoading = true;
    }
}

const _generalReducer = createReducer(
    new GeneralState(),
    on(generalActions.hideLoading, (state, {showLoading}) => {
        return {
            ...state,
            showLoading: showLoading
        };
    }),
    on(generalActions.showLoading, (state, {showLoading}) => {
        return {
            ...state,
            showLoading: showLoading
        };
    })
);

export function generalReducer(state: GeneralState | undefined, action: Action) {
    return _generalReducer(state, action);
}
